import { getCurrentPath } from "@faire/web--source/common/Path";

import { extractVersionNumber } from "./extractVersion";

const getMobileAppVersion = (): string | undefined | null =>
  getCurrentPath().searchParams.get("app_version");

/**
 * Returns true if the current mobile app version is above the baseline version.
 * @param baselineVersion The baseline version to compare against.
 * @returns True if the current mobile app version is above the baseline version.
 * @example
 * CurrentMobileAppVersion: 23.18.0
 * isCurrentMobileAppVersionAbove("23.19.0"); // true
 * isCurrentMobileAppVersionAbove("20.3.1"); // false
 */
export const isCurrentMobileAppVersionAbove = (
  baselineVersion: string
): boolean => {
  const mobileAppVersion = getMobileAppVersion();
  if (!mobileAppVersion) {
    return false;
  }
  const currentAppVersionParts = mobileAppVersion.split(".");
  const baselineVersionParts = baselineVersion.split(".");
  if (
    currentAppVersionParts.length !== 3 ||
    baselineVersionParts.length !== 3
  ) {
    return false;
  }
  const currentYear = currentAppVersionParts[0];
  const currentWeek = currentAppVersionParts[1];
  const currentRevision = extractVersionNumber(currentAppVersionParts[2] ?? "");
  const baselineYear = baselineVersionParts[0];
  const baselineWeek = baselineVersionParts[1];
  const baselineRevision = baselineVersionParts[2];
  if (currentYear && baselineYear) {
    if (parseInt(currentYear) > parseInt(baselineYear)) {
      return true;
    } else if (parseInt(currentYear) < parseInt(baselineYear)) {
      return false;
    } else {
      if (currentWeek && baselineWeek) {
        if (parseInt(currentWeek) > parseInt(baselineWeek)) {
          return true;
        } else if (parseInt(currentWeek) < parseInt(baselineWeek)) {
          return false;
        } else {
          if (currentRevision && baselineRevision) {
            return parseInt(currentRevision) >= parseInt(baselineRevision);
          }
        }
      }
    }
  }
  return false;
};
